import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const banners = [
    {
        href: "/promotion/9ewlf-sieu-deal-cuoi-nam",
        img: "https://gcs.buymed.com/thuocsi-live/images/202574710bcbcc5b1d9faaeae7e9acdb?quality=100",
    },
    {
        href: "/promotion/3q43g-clearance-near-expire--mien-nam",
        img: "https://gcs.buymed.com/thuocsi-live/images/2025b57980eb97576965f5e8cbb9f99e?quality=100",
    },
];

export default function SliderTop() {
    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: "slick-slider",
        dotsClass: "slick-dots slick-thumb",
    };

    return (
        <div className="styles_wrapper_slider__ArKGC">
            <Slider {...settings}>
                {banners.map((item, index) => (
                    <div key={index}>
                        <a href={item.href} title="">
                            <div className="styles_banner_bg_img__JnBFU">
                                <div>
                                    <span style={{ position: "absolute", inset: 0 }}>
                                        <img
                                            src={item.img}
                                            style={{
                                                position: "absolute",
                                                inset: 0,
                                                width: "100%",
                                                height: "auto",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </span>
                                </div>
                            </div>
                        </a>
                    </div>
                ))}
            </Slider>
        </div>
    );
}
